export default function(key: string): string {
  // https://docs.aws.amazon.com/AmazonS3/latest/dev/BucketRestrictions.html
  return key && key.replace(/[^0-9a-zA-Z!\-']/g, '-').toLowerCase();
}
